import { makeStyles } from 'tss-react/mui';

export default makeStyles({ name: 'StartTrialDialog' })({
    root: {},
    paper: {
        borderRadius: 24,
        border: '1px solid rgba(255, 255, 255, 0.05)',
        background: 'rgba(23, 22, 27, 0.75)',
        padding: 24
    },
    backdrop: {
        background: 'rgba(23, 22, 27, 0.75)',
        backdropFilter: 'blur(16px)'
    },
    title: {
        margin: 0,
        color: '#fff',
        textAlign: 'center',
        fontSize: 24,
        fontWeight: 600,
        lineHeight: '36px',
        letterSpacing: '-0.72px',
        userSelect: 'none'
    },
    content: {
        margin: 0,
        color: '#fff',
        textAlign: 'center',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '24px',
        letterSpacing: '-0.32px',
        opacity: 0.75,
        marginTop: 8,
        marginBottom: 24,
        userSelect: 'none'
    },
    actions: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 15
    },
    cancel: {
        height: 44,
        padding: '14px 40px',
        borderRadius: 40,
        background: '#F8F8F8 !important',
        color: '#232323',
        fontSize: 16,
        fontWeight: 600,
        lineHeight: '16px',
        flex: 1
    },
    submit: {
        height: 44,
        padding: '11px 37px',
        borderRadius: 80,
        background: 'transparent !important',
        border: '1.5px solid rgba(255, 255, 255, 0.15) !important',
        color: '#fff !important',
        whiteSpace: 'nowrap',
        fontSize: 16,
        fontWeight: 500,
        lineHeight: '16px',
        flex: 2,
        ['&:disabled']: {
            opacity: 0.75
        }
    }
});
